export const DRIVER_SEND_STATUS = {
    notified: 'Notified',
    copyDriverLink: 'Copy link',
    markNotified: 'Mark notified',
    notifyDrivers: 'Notify drivers',
    copiedLinkToastMessage: 'Paste into WhatsApp for this driver only, then mark them notified.',
} as const

export function driversToNotifyLabel(count: number, onlyDrivers = true): string {
    if (!onlyDrivers) {
        return count === 1 ? '1 crew member to notify' : `${count} crew to notify`
    }
    return count === 1 ? '1 driver to notify' : `${count} drivers to notify`
}
